import React, { Component } from "react";
import { connect } from "react-redux";
import $ from 'jquery';
import initFitnessJS from "../../streaming/FitnessController";
import Language from '../../services/contentData';
import Util from "../../streaming/Util";
import classnames from "classnames";
import whiteboard from "../../utils/whiteboardNew";
import InstructorTutorial from "./InstructorTutorial";
import axios from "axios";
import InstructorToolTip from "./InstructorToolTip";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Const from "../../constants/Constants";
import audioPlay from "../../utils/audioPlay";
import moment from 'moment';

class MemberFitnessScript extends Component {
  
  constructor() {
    super();

    this.state = {
		userData:'',
		activityArray: [],
		sliderWidth: '250px',
		movedLeftCount: 0,
		movedLeft: '0px',
		maxMoveLeft: 0,
		classStartTimer: '00:00',
    };
	this.xInterval = null;
	window['sessionStartedBeforeMemberJoin'] = this.sessionStartedBeforeMemberJoin;
  }

  componentWillMount = () =>{
	  if ( localStorage.getItem('userData') )   
			{
				var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
				
				if ( sessionData.scriptDetail && sessionData.scriptDetail.length > 0 ) 
					{ 				
						if ( !sessionData.ondemandId ) 
							{
								for ( let i = 0; i < sessionData.scriptDetail.length; i++ )
									{
										if ( sessionData.scriptDetail[i]['attribute'][0]['attrValue'] == 'Pause' || sessionData.scriptDetail[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
											{
												sessionData.scriptDetail.splice(i, 1);
												i--;
											}
									}
							}
						let sliderWidthValue = sessionData.scriptDetail.length * 250;
						sliderWidthValue= sliderWidthValue+'px'; 
						this.setState({
							activityArray: sessionData.scriptDetail,
							sliderWidth: sliderWidthValue,
						}, ()=>{
							let mainDivWidth = $('.memberMainScript').width();
							let activitesDisplayed = mainDivWidth / 250;
							activitesDisplayed = Math.floor(activitesDisplayed);
							
							let totalActivities = sessionData.scriptDetail.length;
							let maxMoveNum = totalActivities - activitesDisplayed;
							
							this.setState({
								maxMoveLeft: maxMoveNum,
							});
						});
					}
				else 
					{
						this.props.updateStateFromChild({showMemerFitnessScript: false});
					}					
					
				let currDate = new Date(sessionData.scheduleDate);
				this.countdownTimer(currDate);
			}
  }

  componentDidMount = () => {
 
  }
  
  componentWillUnmount(){
	clearInterval(this.xInterval);
  }
  
  countdownTimer=(sessionDate)=>{
	  var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
	  var startDate = moment(sessionData.scheduleDate).format("MM/DD/YYYY hh:mm");
	  
	  let sessionStartTime = new Date(sessionData.scheduleDate).getTime();
	  
	  var now = '';
	  var timeToStartClass = '';
	  var mainthis = this;
	  
	  this.xInterval = setInterval(function() {
		   now = new Date().getTime();
		   timeToStartClass = sessionStartTime - now;
		   
		   if ( timeToStartClass > 0 )
			{
				var secsLeft = ("0" + (Math.floor((timeToStartClass / 1000) % 60) % 60)).slice(-2);
				var minsLeft = ("0" + Math.floor((timeToStartClass / 60000) % 60)).slice(-2);
					
				let setTimer = minsLeft + ":" + secsLeft;
				mainthis.setState({
					classStartTimer: setTimer,
				});
			}
		   else 
			{
				mainthis.setState({
					classStartTimer: 'Class should start soon',
				});
				//clearInterval(mainthis.xInterval);
				//mainthis.props.updateStateFromChild({showMemerFitnessScript: false});
			}
			
	  }, 500);
  }
  
  sessionStartedBeforeMemberJoin=()=>{
		clearInterval(this.xInterval);
		this.props.updateStateFromChild({showMemerFitnessScript: false});
		window['showMemerFitnessScript'] = false;
  }
  
  moveScript=()=>{
	  let leftValue = this.state.movedLeftCount
	  leftValue = leftValue + 1;
	  let totalMoveLeft = leftValue * 250;
	  var leftInPx = '-'+totalMoveLeft+'px';
	  this.setState({
		  movedLeftCount: leftValue,
		  movedLeft: leftInPx,
	  });
  }

	backScript=()=>{
		let leftValue = this.state.movedLeftCount
		if ( leftValue == 1 )
			{
				this.setState({
					movedLeftCount: 0,
					movedLeft: '0px',
				});
			}
		else 
			{
				leftValue = leftValue - 1;
				let totalMoveLeft = leftValue * 250;
				var leftInPx = '-'+totalMoveLeft+'px';
				this.setState({
					movedLeftCount: leftValue,
					movedLeft: leftInPx,
				});
			}			
	}		

  render() {
    return (
		<div className="memberScriptHolderMain">
			{this.state.classStartTimer != 'Class should start soon' ?
				<div className="memberScriptH1">Waiting for class to start in 
					<span className="timerSpanScript">{this.state.classStartTimer}</span> 
				</div>
				:
				<div className="memberScriptH1">{this.state.classStartTimer}</div>
			}
			<div className="upcomingText">Upcoming Activities</div>
			<div className="memberMainScript">
				{ this.state.maxMoveLeft > this.state.movedLeftCount &&
					<div className="scrollSliderHolder" onClick={()=>this.moveScript()} ></div>
				}
				{this.state.movedLeftCount != 0 &&
					<div className="scrollSliderHolder memberLeftSlider" onClick={()=>this.backScript()} ></div> 
				}
				<div className="scrollPartMember" style={{width: this.state.sliderWidth, left: this.state.movedLeft}}>
					{ this.state.activityArray.map((item, i) => 
						<div className="memberActivityHold" >
							<div className="memberActivityNameH1">
								{ item.attribute[12] && item.attribute[12].attrValue && item.attribute[12].attrValue !== '' ? 
									<span>{item.attribute[12].attrValue}</span>
									:
									<span> 
										{item.name} 
										{ item.attribute[4].attrValue && item.attribute[4].attrValue !== '' && 
											<div className="play_activity" onClick={() => this.props.playActivityVideo(item.attribute[4].attrValue)}></div>
										}
									</span>
								}
							</div>
							<div className="">
								<span className="actDurationSpan">{item.attribute[2].attrValue}</span>
								<span className="actDurationValueSpan">Seconds</span>
							</div>
						</div>	
					)} 			
				</div>
			</div>
		</div>
	);
  }
}
export default connect(
  null,
  {},
  null,
  {forwardRef: true}
)(MemberFitnessScript); 